import { EntityType } from '../../../@types/entityTypes';
import instanceQuery from '../../queries/product/ConsolidatedPickGroupQuery.graphql';
import workspaceQuery from '../../queries/product/ConsolidatedPickGroupWorkspaceQuery.graphql';
import defaultQuery from '../../queries/product/ConsolidatedPickGroupDefault.graphql';
import mutationQuery from '../../mutations/product/ConsolidatedPickGroupMutation.graphql';
import listQuery from '../../queries/product/ConsolidatedPickGroupListQuery.graphql';

const ConsolidatedPickGroup: EntityType = {
  type: 'ConsolidatedPickGroup',
  title: 'Consolidated Pick Groups',
  formTitle: 'Consolidated Pick Group',
  formUrl: '/Products/StockControl/ConsolidatedPickGroup/Details/',
  workspaceUrl: '/Products/StockControl/ConsolidatedPickGroup/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  screenReference: 'CONSOLIDATED_PICK_GROUPS',
};

export default ConsolidatedPickGroup;
